import MarketingAndPrivacyComponent from './MarketingAndPrivacyComponent';

export default MarketingAndPrivacyComponent;